import isIP from "validator/es/lib/isIP";
import isFQDN from "validator/es/lib/isFQDN";

import { useNavigate } from "react-router-dom";
import { route } from "../../../shim/jsbridge";
import { FIRST_COLON_ONLY_REGEX } from "../../search/consts";
import { removeSurroundingQuotes } from "../util";
import { isValidHttpUrl } from "../../../utils";

export type NavigateToNtiType = (value: string) => void;

const NETWORK_ROUTES: Record<string, string> = {
  IP_SUMMARY: "network_ip_summary",
  DOMAIN_SUMMARY: "network_domain_summary",
  URL_SUMMARY: "network_url_summary"
};

const useNetworkNavigation = (linksReloadDocument?: boolean) => {
  const navigate = useNavigate();

  const navigateTo = (routeValue: string, value: string) => {
    const encodedUriComponent = encodeURIComponent(value);
    const destination = route(routeValue, [encodedUriComponent]);
    if (linksReloadDocument) {
      window.location = destination;
      return;
    }
    navigate(destination);
  };

  const navigateToIpPage: NavigateToNtiType = ip => {
    navigateTo(NETWORK_ROUTES.IP_SUMMARY, ip);
  };

  const navigateToDomainPage: NavigateToNtiType = domain => {
    navigateTo(NETWORK_ROUTES.DOMAIN_SUMMARY, domain);
  };

  const navigateToUriPage: NavigateToNtiType = uri => {
    navigateTo(NETWORK_ROUTES.URL_SUMMARY, uri);
  };

  const navigateToFn = (value: string) => {
    if (isIP(value)) return navigateToIpPage(value);
    if (isFQDN(value)) return navigateToDomainPage(value);
    if (isValidHttpUrl(value)) return navigateToUriPage(value);
    return undefined;
  };

  const navigateToNti = (ntiString: string) => {
    if (!ntiString) return;
    const [, value] = ntiString.split(FIRST_COLON_ONLY_REGEX);
    navigateToFn(removeSurroundingQuotes(value));
  };

  return {
    navigateToIpPage,
    navigateToDomainPage,
    navigateToUriPage,
    navigateToNti
  };
};

export default useNetworkNavigation;
